module.exports = __webpack_public_path__ + "static/media/A5.7d3a5ee0.jpg";